<template>
  <div class="content-container">
    <div class="das-form-container mb-2">
      <div class="das-form-input">
        <!-- :suppress-row-hover-highlight="true" -->
        <select-with-search-table
          style="width: 400px"
          :rows="groupList"
          :dropdown-width="450"
          :columns="groupOptionsCol"
          :value="groupId"
          :selected-index-field-value="groupId"
          index-field="id"
          @selectionChanged="changeGroupSelect"
        >
          <!-- :value="groupId" -->
          <template v-slot:value="{ selectedValue: selectedData }">
            {{ selectedData?.name }}
          </template>
        </select-with-search-table>
        <!-- <el-select
          v-model="groupId"
          class="w-20"
          style="flex: 1"
          placeholder="Chọn đoàn"
          @change="fnGetTransGeneralInfo"
        >
          <el-option
            v-for="(item, index) in groupList"
            :key="index"
            :value="item.id"
            :label="item.booking_code"
          >
          </el-option>
        </el-select> -->
      </div>
      <!-- <div class="search-item">
        <input style="width: 300px" type="text" placeholder="Đoàn" />
      </div> -->
    </div>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-group mb-2">
            <div class="das-form-group-title">Thông tin khách</div>
            <InfoList
              :columns="3"
              :column-breakpoint-options="{
                sm: 1,
                md: 3
              }"
            >
              <InfoListLabel>Số tài khoản</InfoListLabel>
              <InfoListValue>{{ customerInfo.account_num }} </InfoListValue>

              <InfoListLabel>Ngày đến</InfoListLabel>
              <InfoListValue>{{ customerInfo.arrive_date }}</InfoListValue>

              <InfoListLabel>Số dư</InfoListLabel>
              <InfoListValue>{{
                $displayCurrency(customerInfo.money_balance)
              }}</InfoListValue>

              <InfoListLabel>Tên</InfoListLabel>
              <InfoListValue>{{ customerInfo.name }}</InfoListValue>

              <InfoListLabel>Ngày đi</InfoListLabel>
              <InfoListValue>{{ customerInfo.depart_date }} </InfoListValue>

              <!-- <InfoListLabel>Số phòng</InfoListLabel>
              <InfoListValue>{{ customerInfo.roomNum }}</InfoListValue> -->
            </InfoList>
          </div>
          <span v-if="customerInfo.transaction_page.length === 0"
            >Dữ liệu danh sách giao dịch trống</span
          >
          <div v-else class="flex column gap-0 flex-1">
            <tab
              v-model="tabIndex"
              :tab-list="customerInfo.transaction_page"
              @input="onTabChange"
            />
            <!--  -->
            <div
              v-for="(item, index) in customerInfo.transaction_page"
              :key="index"
              class="mt-10 none flex-1"
              :class="{ block: tabIndex === index + 1 }"
              style="height: 300px"
            >
              <!-- :class="{ block: tabIndex === index + 1 }"
            v-if="tabIndex === index + 1" -->
              <GridVx
                v-if="tabIndex === index + 1"
                :ref="'transactionGrid'"
                :columns="columns"
                dom-layout="scroll"
                :auto-size-cell="true"
                :row-multi-select-with-click="true"
                :rows="transactionRows"
                class="agGrid"
                @selectionChanged="onSelectTransaction"
              />
            </div>
          </div>
          <div class="button-containers">
            <!-- <button
              :disabled="!groupId"
              class="btn primary small"
              @click="transferRoutingDialog = true"
            >
              Chuyển routing
            </button> -->
            <button
              :disabled="selectedRows.length === 0"
              class="btn primary small"
              @click="transferTransactionDialog = true"
            >
              Chuyển giao dịch
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Start of transfer routing -->
    <el-dialog
      title="Chuyển Routing"
      :visible.sync="transferRoutingDialog"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-group-title">Chuyển từ</div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="das-form-input in-line">
                    <div class="label">
                      <span class="required">Trang giao dịch</span>
                    </div>
                    <!-- <select v-model="createRoutingForm.trans_page_org">
                    <option
                      v-for="item in tabList"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </option>
                  </select> -->
                    <validation-provider
                      style="width: 100%"
                      rules="required"
                      name="Trang giao dịch đi"
                    >
                      <el-select
                        v-model="createRoutingForm.trans_page_org"
                        placeholder=""
                      >
                        <el-option
                          v-for="item1 in tabList.filter(
                            item => item.value !== 9999
                          )"
                          :key="item1.id"
                          :label="`${item1.code} - ${item1.desc}`"
                          :value="item1.id"
                        >
                        </el-option>
                      </el-select>
                    </validation-provider>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="das-form-input in-line">
                    <div class="label">
                      <span>Mã giao dịch</span>
                    </div>
                    <el-select
                      v-model="createRoutingForm.transaction_id"
                      placeholder=""
                    >
                      <el-option :key="9999" :value="null" label="Tất cả" />
                      <el-option
                        v-for="item in transactionList"
                        :key="item.id"
                        :label="item.description"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <!-- <select v-model="createRoutingForm.transaction_id">
                    <option :value="null">Tất cả</option>
                    <option></option>
                    <option
                      v-for="item in transactionList"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.description }}
                    </option>
                  </select> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="das-form-input in-line">
                    <div class="label">
                      <span class="required">Mã GD phụ</span>
                    </div>
                    <el-select
                      v-model="createRoutingForm.sub_transaction_id"
                      placeholder=""
                    >
                      <el-option :key="9999" :value="null" label="Tất cả" />
                      <el-option
                        v-for="item in subTransactionList"
                        :key="item.id"
                        :label="`${item.description}-(${item.code})`"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <!-- <select v-model="createRoutingForm.sub_transaction_id">
                    <option :value="null">Tất cả</option>
                    <option
                      v-for="item in subTransactionList"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.description }}
                    </option>
                  </select> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-group">
            <div class="das-form-group-title">Chuyển đến</div>
            <!-- <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input in-line">
                  <div class="label">
                    <span class="required">Đặt phòng</span>
                  </div>
                  <div style="display: flex; gap: 10px; width: 100%">
                    <validation-provider
                      style="width: 100%"
                      rules="required"
                      name="Thông tin đặt phòng"
                    >
                      <input
                        v-model="createRoutingForm.sub_booking_group_name_des"
                        type="text"
                        disabled
                      />
                    </validation-provider>
                    <das-button
                      color="primary"
                      size="small"
                      append-icon="search"
                      @click="searchRoomOnTransferTransactionDialog()"
                    />
                  </div>
                </div>
              </div>
            </div> -->
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input in-line">
                  <div class="label">
                    <span class="required">Trang giao dịch</span>
                  </div>
                  <validation-provider
                    style="width: 100%"
                    rules="required"
                    name="Trang giao dịch đến"
                  >
                    <el-select
                      v-model="createRoutingForm.trans_page_des"
                      placeholder=""
                    >
                      <el-option
                        v-for="item1 in tabList"
                        :key="item1.id"
                        :label="
                          item1.desc
                            ? `${item1.code} - ${item1.desc}`
                            : item1.code
                        "
                        :value="item1.id"
                      >
                      </el-option>
                    </el-select>
                  </validation-provider>
                  <!-- <select v-model="createRoutingForm.trans_page_des">
                  <option
                    v-for="item in tabList"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </option>
                </select> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="transferRoutingDialog = false"
          >
            Đóng
          </button>
          <button class="btn primary small" @click="onRoutingSubmit">
            Đồng ý
          </button>
        </div>
      </span>
    </el-dialog>
    <!-- End of transfer routing -->

    <!-- transfer Transaction -->
    <el-dialog
      v-if="selectedRows.length !== 0"
      title="Chuyển giao dịch"
      :visible.sync="transferTransactionDialog"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-group-title">Chuyển từ</div>
          <InfoList :columns="2">
            <InfoListLabel>Tên khách</InfoListLabel>
            <InfoListValue>{{ customerInfo.name }}</InfoListValue>

            <InfoListLabel>Đặt phòng</InfoListLabel>
            <InfoListValue>{{ selectedRows[0]?.room_num }}</InfoListValue>

            <InfoListLabel>Trang hiện tại</InfoListLabel>
            <InfoListValue>{{
              customerInfo.transaction_page[tabIndex - 1]?.label
            }}</InfoListValue>
          </InfoList>
        </div>
        <div class="das-form-group mt-10">
          <div class="das-form-group-title">Chuyển đến</div>
          <validation-observer ref="tranferTransactionsFormValidator">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input in-line">
                  <div class="label">
                    <span class="required">Đặt phòng</span>
                  </div>
                  <div style="display: flex; gap: 10px; width: 100%">
                    <validation-provider
                      rules="required"
                      :name="'Đặt phòng'"
                      style="width: 100%"
                    >
                      <input
                        v-model="transferTransactionSubmitForm.room_code"
                        disabled
                        type="text"
                      />
                    </validation-provider>
                    <das-button
                      color="primary"
                      size="small"
                      append-icon="search"
                      @click="searchRoomOnTransferTransactionDialog(1)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="das-form-input in-line">
                    <div class="label">Tên khách</div>
                    <span class="value">{{
                      transferTransactionSubmitForm.customer_name
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input in-line">
                  <div class="label">Phòng</div>
                  <span class="value">{{
                    transferTransactionSubmitForm.room_num
                  }}</span>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input in-line">
                  <div class="label">
                    <span class="required">Trang giao dịch</span>
                  </div>
                  <validation-provider
                    rules="required"
                    :name="'Trang giao dịch'"
                    style="width: 100%"
                  >
                    <!-- <select v-model="transferTransactionSubmitForm.trans_page">
                    <option
                      v-for="item in customerInfo.transaction_page"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </option>
                  </select> -->
                    <el-select
                      v-model="transferTransactionSubmitForm.trans_page"
                      style="flex: 1"
                      placeholder="Chọn trang"
                    >
                      <el-option
                        v-for="(item, index) in tranpageOptions"
                        :key="index"
                        :value="item.id"
                        :label="`${item.code} - ${item.desc}`"
                      >
                      </el-option>
                    </el-select>
                  </validation-provider>
                </div>
              </div>
            </div>
          </validation-observer>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="transferTransactionDialog = false"
          >
            Đóng
          </button>
          <button class="btn primary small" @click="onTransferTransaction">
            Đồng ý
          </button>
        </div>
      </span>
    </el-dialog>

    <!-- search Folio -->
    <el-dialog
      title="Tìm FOLIO để chuyển giao dịch"
      :visible.sync="searchFolioDialog"
      :close-on-click-modal="false"
      width="900px"
    >
      <div class="das-form-container">
        <!-- basic search -->
        <div class="das-form-group">
          <div class="das-form-group-title">Tìm thông tin</div>
          <hr />
          <validation-observer ref="validateSearchForm">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">{{ $t('field.customerName') }}</div>
                  <validation-provider
                    rules="max:200"
                    :name="$t('field.customerName')"
                  >
                    <input
                      v-model="searchParamsFolio.customerInfo"
                      type="text"
                    />
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">{{ $t('field.bookingGroupName') }}</div>
                  <validation-provider
                    rules="max:200"
                    :name="$t('field.bookingGroupName')"
                  >
                    <input v-model="searchParamsFolio.groupInfo" type="text" />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Hạng/Số phòng</div>
                  <div style="display: flex; gap: 10px">
                    <el-select
                      v-model="searchParamsFolio.roomLevelId"
                      placeholder="Hạng"
                    >
                      <el-option :key="9999" :value="null" label="Tất cả" />
                      <el-option
                        v-for="item in roomLevelOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <el-select
                      v-model="searchParamsFolio.roomId"
                      placeholder="Số phòng"
                    >
                      <el-option :key="9999" :value="null" label="Tất cả" />
                      <el-option
                        v-for="item in roomOptions"
                        :key="item.id"
                        :label="item.room_num"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="das-form-col col-6">
                <!-- <div class="das-form-input">
                  <div class="das-form-input">
                    <div class="label">{{ $t('field.numOfGuest') }}</div>
                    <validation-provider
                      rules="max_value:10000"
                      :name="$t('field.numOfGuest')"
                    >
                      <input
                        v-model="searchParamsFolio.guestNum"
                        onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight', 'Tab'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                        type="number"
                      />
                    </validation-provider>
                  </div>
                </div> -->
              </div>
            </div>
          </validation-observer>
        </div>
        <!--advance search -->
        <div class="das-form-group">
          <div class="das-form-group-title">Tìm kiếm nâng cao</div>
          <hr />
          <validation-observer ref="validateAdvanceSearchForm">
            <div class="das-form-row">
              <div class="flex gap-20">
                <div class="das-form-col col-6">
                  <div class="das-form-input">
                    <div class="label">{{ 'Họ' }}</div>
                    <validation-provider rules="max:30" :name="'Họ'">
                      <input
                        v-model="searchParamsFolioAdvance.last_name"
                        type="text"
                      />
                    </validation-provider>
                  </div>
                </div>
                <div class="das-form-col col-6">
                  <div class="das-form-input">
                    <div class="label">Tên</div>
                    <validation-provider rules="max:30" :name="'Tên'">
                      <input
                        v-model="searchParamsFolioAdvance.first_name"
                        type="text"
                      />
                    </validation-provider>
                  </div>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Quốc gia</div>
                  <el-select
                    v-model="searchParamsFolioAdvance.nation_id"
                    placeholder=""
                  >
                    <el-option :key="9999" :value="null" label="Tất cả" />
                    <el-option
                      v-for="item in nationOptions"
                      :key="item.id"
                      :label="item.desc"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Công ty</div>
                  <el-select
                    v-model="searchParamsFolioAdvance.agent_id"
                    placeholder="Công ty"
                  >
                    <el-option :key="9999" :value="null" label="Tất cả" />
                    <el-option
                      v-for="item in agentList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">{{ $t('field.marketSegment') }}</div>
                  <el-select
                    v-model="searchParamsFolioAdvance.market_seg_id"
                    placeholder="Công ty"
                  >
                    <el-option :key="9999" :value="null" label="Tất cả" />
                    <el-option
                      v-for="item in marketSegmentList"
                      :key="item.id"
                      :label="`${item.code} - ${item.desc}`"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <!-- <div class="das-form-row">
            </div> -->
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Ngày đến</div>
                  <CalendarRange
                    v-model="arrivalDate"
                    style="display: block"
                    mode="date"
                  />
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Ngày đi</div>
                  <CalendarRange
                    v-model="departDate"
                    style="display: block"
                    mode="date"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-row"></div>
          </validation-observer>
        </div>
        <!-- registration room status -->
        <!-- <div class="das-form-group">
          <div class="das-form-group-title">Trạng thái đặt phòng</div>
          <hr />
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="checkbox-container">
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp1"
                    v-model="searchParamsFolioAdvance.booked"
                    type="checkbox"
                  />
                  <label for="cpSpdTp1">Đã đặt</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp2"
                    v-model="searchParamsFolioAdvance.is_checked_out_today"
                    type="checkbox"
                  />
                  <label for="cpSpdTp2">Đã trả phòng hôm nay</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp3"
                    v-model="searchParamsFolioAdvance.is_canceled"
                    type="checkbox"
                  />
                  <label for="cpSpdTp3">Đã hủy</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp4"
                    v-model="searchParamsFolioAdvance.is_arrive_today"
                    type="checkbox"
                  />
                  <label for="cpSpdTp4">Đến hôm nay</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp5"
                    v-model="searchParamsFolioAdvance.is_not_arrive"
                    type="checkbox"
                  />
                  <label for="cpSpdTp5">Không đến</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp6"
                    v-model="searchParamsFolioAdvance.is_not_checkout"
                    type="checkbox"
                  />
                  <label for="cpSpdTp6">Đang ở</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp7"
                    v-model="searchParamsFolioAdvance.is_checkout"
                    type="checkbox"
                  />
                  <label for="cpSpdTp7">Đã trả phòng</label>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row align-end">
            <div class="das-form-col col-12">
              <div class="checkbox-container">
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp8"
                    v-model="searchParamsFolioAdvance.is_definite"
                    type="checkbox"
                  />
                  <label for="cpSpdTp8">Definite</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp9"
                    v-model="searchParamsFolioAdvance.is_waiting"
                    type="checkbox"
                  />
                  <label for="cpSpdTp9">Waiting</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp10"
                    v-model="searchParamsFolioAdvance.is_tentative"
                    type="checkbox"
                  />
                  <label for="cpSpdTp10">Tentatvie</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp11"
                    v-model="searchParamsFolioAdvance.exactly"
                    type="checkbox"
                  />
                  <label for="cpSpdTp11">Chính xác</label>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="searchFolioDialog = false"
          >
            Đóng
          </button>
          <button class="btn primary small outline" @click="onReset">
            Xóa filter
          </button>
          <button class="btn primary small" @click="searchFolio">
            Tìm kiếm
          </button>
          <button class="btn primary small" @click="searchFolioAdvance">
            Tìm kiếm nâng cao
          </button>
        </div>
      </span>
    </el-dialog>

    <!-- List Folio Popup -->
    <el-dialog
      title="Tìm FOLIO để chuyển giao dịch"
      :visible.sync="folioListDialog"
      :close-on-click-modal="false"
      width="900px"
    >
      <div class="mt-10" style="height: 400px">
        <GridVx
          ref="folioListGrid"
          :columns="folioListCols"
          dom-layout="scroll"
          :rows="folioListRows"
          class="agGrid"
          @selectionChanged="onSelectFolioRows"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="folioListDialog = false"
          >
            Đóng
          </button>
          <button class="btn primary small" @click="onFolioSelect">Chọn</button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders.js'
import {
  searchFolioApi,
  searchFolioAdvanceApi,
  transferTransactionApi,
  getTranPageById,
  postRouting
} from '@/api/cashier_service/postTransaction'
import { getBookingGroupListApi } from '@/api/booking_service/bookingGroupApi'
import { getRoom } from '@/api/reception/common'
import {
  getTransGeneralInfo,
  getTransactionByPage,
  codeBaseApi
} from '@/api/booking_service/bookingGroup'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'
import { getAgent } from '@/api/reception/common.js'
// import
import { getMarketSegmentApi } from '@/api/common/marketSegment'
import DasButton from '@/components/ui/DasButton.vue'
import Tab from '@/components/Tab'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { getCodeBase } from '@/api/common/code_base'
import { getListSubTransactionApi } from '@/api/configuration/accounting/subTransaction'
import { getTransactionListApi } from '@/api/common/transaction'

export default {
  components: {
    DasButton,
    CalendarRange,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckboxReadonly,
    Tab
  },
  data() {
    return {
      transferRoutingDialog: false,
      transferTransactionDialog: false,
      dialogSearchFolioVisible: false,
      folioListDialog: false,
      searchFolioDialog: false,

      groupId: null,
      groupList: [],
      createRoutingForm: {
        trans_page_org: null,
        sub_booking_group_id_org: null,
        trans_page_des: null,
        sub_booking_group_id_des: null,
        sub_booking_group_name_des: null,
        transaction_id: null,
        sub_transaction_id: null
      },
      customerInfo: {
        // surplus: null,
        account_num: null,
        name: null,
        arrive_date: null,
        depart_date: null,
        id: null,
        code: null,
        money_balance: null,
        transaction_page: []
      },
      customerInfoDefault: {
        // surplus: null,
        account_num: null,
        name: null,
        arrive_date: null,
        depart_date: null,
        id: null,
        code: null,
        money_balance: null,
        transaction_page: []
      },
      // customerInfo: {
      //   bankNumber: null,
      //   arrivalDate: null,
      //   remainingMoney: null,
      //   name: null,
      //   departDate: null,
      //   roomNum: null
      // },
      transferTransactionSubmitForm: {
        trans_page: null,
        sub_booking_group_id: null,
        room_num: null,
        room_code: null,
        customer_name: null
      },
      transferTransactionSubmitFormDefault: {
        trans_page: null,
        sub_booking_group_id: null,
        room_num: null,
        room_code: null,
        customer_name: null
      },
      tabIndex: 1,
      roomLevelOptions: [],
      roomOptions: [],
      nationOptions: [],
      marketSegmentList: [],
      agentList: [],
      tranpageOptions: [],
      nationalityCols: [
        {
          headerName: this.$t('config.profile.select.nationalityCode'),
          field: 'code',
          tooltipField: 'code'
        },
        {
          headerName: this.$t('config.profile.select.nationalityName'),
          field: 'desc',
          tooltipField: 'desc'
        }
      ],

      searchFolioType: 1, // 1 - router, 2 - transfer
      searchParamsFolio: {
        customerInfo: null,
        groupInfo: null,
        roomLevelId: null,
        roomId: null,
        guestNum: null
      },
      searchParamsFolioDefaut: {
        customerInfo: null,
        groupInfo: null,
        roomLevelId: null,
        roomId: null,
        guestNum: null
      },
      searchParamsFolioAdvance: {
        first_name: null,
        last_name: null,
        price_code_id: null,
        arrive_date_from: null,
        arrive_date_to: null,
        depart_date_from: null,
        depart_date_to: null,
        agent_name: null,
        agent_id: null,
        nation_id: null,
        market_seg_id: null,
        booked: false,
        is_arrive_today: false,
        is_not_checkout: false,
        is_checked_out_today: false,
        is_checkout: false,
        is_canceled: false,
        is_not_arrive: false,
        is_definite: false,
        is_tentative: false,
        is_waiting: false,
        exactly: false
      },

      searchParamsFolioAdvanceDefault: {
        first_name: null,
        last_name: null,
        price_code_id: null,
        arrive_date_from: null,
        arrive_date_to: null,
        depart_date_from: null,
        depart_date_to: null,
        agent_name: null,
        agent_id: null,
        nation_id: null,
        market_seg_id: null,
        booked: false,
        is_arrive_today: false,
        is_not_checkout: false,
        is_checked_out_today: false,
        is_checkout: false,
        is_canceled: false,
        is_not_arrive: false,
        is_definite: false,
        is_tentative: false,
        is_waiting: false,
        exactly: false
      },

      searchParams: {
        customer_info: null,
        group_info: null,
        company_info: null,
        long_stay: null,
        arrive_from: null,
        arrive_to: null,
        depart_from: null,
        depart_to: null,
        surplus: null,
        check_out_today: null,
        reserved: null,
        in_house: true,
        checked_out: null
      },

      tranferInfo: {
        roomInfo: null,
        guestName: null,
        room: null,
        transactionPage: null
      },
      groupOptionsCol: [
        {
          headerName: 'Mã đoàn',
          field: 'booking_code',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Tên đoàn',
          field: 'name',
          // cellClass: "grid-cell-centered",
          flex: 1,
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Tên khách',
          field: 'traveller_name',
          // cellClass: "grid-cell-centered",

          minWidth: 100,
          maxWidth: 150
        }
      ],

      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
          // cellStyle: {'padding-left': '12px'}
        },
        {
          headerName: 'Mã đặt phòng',
          field: 'sub_booking_group_code',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Ngày',
          field: 'date',
          // cellRenderer: params => {
          //   return params.value
          //     ? this.$moment(params.value).format('DD-MM-YYYY')
          //     : null
          // },
          // tooltipValueGetter: params => {
          //   return params.value
          //     ? this.$moment(params.value).format('DD-MM-YYYY')
          //     : null
          // },
          minWidth: 120,
          maxWidth: 130
        },
        {
          headerName: 'Mã',
          field: 'sub_transaction_code',
          tooltipField: 'sub_transaction_code',
          minWidth: 100
        },

        {
          headerName: 'Mô tả',
          field: 'sub_transaction_des',
          tooltipField: 'sub_transaction_des',
          minWidth: 100
        },
        // {
        //   headerName: 'Số tiền gốc',
        //   field: 'root_money',
        //   minWidth: 100
        // },
        {
          headerName: 'Số tiền',
          field: 'money',
          tooltipField: 'money',
          valueGetter: param => {
            if (param?.data?.money) {
              return this.$displayCurrency(param.data.money)
            } else {
              return 0
            }
          },
          minWidth: 100
        },
        {
          headerName: 'Phòng gốc',
          field: 'room_num',
          tooltipField: 'room_num',
          minWidth: 100
        },
        {
          headerName: 'Nhân viên',
          field: 'user_name',
          tooltipField: 'user_name',
          minWidth: 80
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          tooltipField: 'note',
          minWidth: 100
        }
      ],
      transactionRows: [],
      selectedRows: [],

      selectedFolio: null,
      folioListCols: [
        // {
        //   headerName: this.$t('grid.column.customerStatus'),
        //   field: 'customer_status',
        //   headerTooltip: this.$t('grid.column.customerStatus'),
        //   tooltipField: 'customer_status',
        //   width: 150
        // },
        {
          headerName: this.$t('grid.column.reservation'),
          field: 'room_code',
          headerTooltip: this.$t('grid.column.reservation'),
          tooltipField: 'room_code',
          width: 150
        },
        // {
        //   headerName: this.$t('grid.column.confirm'),
        //   field: 'confirm_code',
        //   tooltipField: 'confirm_code',
        //   width: 150
        // },
        {
          headerName: this.$t('grid.column.name'),
          field: 'full_name',
          tooltipField: 'full_name',
          width: 150
        },
        // {
        //   headerName: this.$t('grid.column.price'),
        //   field: 'invoice_num',
        //   width: 150
        // },
        {
          headerName: this.$t('grid.column.vip'),
          field: 'vip',
          cellRenderer: 'CellRenderCheckboxReadonly',
          minWidth: 50,
          maxWidth: 50
        },
        {
          headerName: this.$t('grid.column.room'),
          tooltipField: 'room_num',
          field: 'room_num',
          minWidth: 100,
          maxWidth: 100
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          tooltipField: 'room_level',
          headerTooltip: this.$t('grid.column.roomLevel'),
          field: 'room_level',
          width: 150
        },
        {
          headerName: this.$t('grid.column.roomLevelReservation'),
          field: 'room_level_book',
          headerTooltip: this.$t('grid.column.roomLevelReservation'),
          tooltipField: 'room_level_book',
          width: 150
        },
        {
          headerName: this.$t('grid.column.comeDate'),
          field: 'arrive_date',
          cellRenderer: params => {
            return params.value
              ? this.$moment(params.value).format('DD-MM-YYYY')
              : null
          },
          tooltipValueGetter: params => {
            return params.value
              ? this.$moment(params.value).format('DD-MM-YYYY')
              : null
          },
          width: 150
        },
        {
          headerName: this.$t('grid.column.departDate'),
          field: 'depart_date',
          cellRenderer: params => {
            return params.value
              ? this.$moment(params.value).format('DD-MM-YYYY')
              : null
          },
          tooltipValueGetter: params => {
            return params.value
              ? this.$moment(params.value).format('DD-MM-YYYY')
              : null
          },
          width: 150
        },
        {
          headerName: 'NL/TE',
          field: 'nl',
          cellRenderer: params => {
            return params.data.nl + '/' + params.data.te
          },
          tooltipValueGetter: params => {
            return params.data.nl + '/' + params.data.te
          },
          minWidth: 70,
          maxWidth: 70
        },
        // {
        //   headerName: 'MFC',
        //   field: 'create_date',
        //   width: 150
        // },
        {
          headerName: this.$t('grid.column.group'),
          field: 'group_code',
          tooltipField: 'group_code',
          width: 150
        },
        {
          headerName: this.$t('grid.column.companyName'),
          field: 'agent_name',
          headerTooltip: 'Giá một đêm',
          tooltipField: 'agent_name',
          width: 150
        }
      ],
      folioListRows: [],
      tabList: [],
      transactionList: [],
      subTransactionList: [],
      allTranPages: [],
      key: null
    }
  },
  computed: {
    arrivalDate: {
      get() {
        return {
          start: this.searchParamsFolioAdvance.arrive_date_from,
          end: this.searchParamsFolioAdvance.arrive_date_to
        }
      },
      set(newValue) {
        this.searchParamsFolioAdvance.arrive_date_from = newValue.start
        this.searchParamsFolioAdvance.arrive_date_to = newValue.end
      }
    },
    departDate: {
      get() {
        return {
          start: this.searchParamsFolioAdvance.depart_date_from,
          end: this.searchParamsFolioAdvance.depart_date_to
        }
      },
      set(newValue) {
        this.searchParamsFolioAdvance.depart_date_from = newValue.start
        this.searchParamsFolioAdvance.depart_date_to = newValue.end
      }
    }
  },
  watch: {
    transferRoutingDialog(value) {
      if (value) {
        this.createRoutingForm.trans_page_org = this.tranpageOptions[0]?.id
        this.createRoutingForm.trans_page_des = this.tranpageOptions[0]?.id
        this.createRoutingForm.transaction_id = null
        this.createRoutingForm.sub_transaction_id = null
      }
    },
    key() {
      this.tabList = []
      if (this.bookingInfo?.id) {
        this.getTranPageById(this.bookingInfo.id, true)
      }
    },
    async 'createRoutingForm.transaction_id'() {
      this.subTransactionList = []
      this.createRoutingForm.sub_transaction_id = null
      const params = {
        transactionId: this.createRoutingForm.transaction_id
      }
      const data = await getListSubTransactionApi(params)
      this.subTransactionList = data.data ?? []
      // console.log('subTransactionList', this.subTransactionList)
    },
    async routingIndex() {
      await this.getRoutingRows()
    },
    addRoutingDialog() {
      this.addRoutingDialog
        ? this.openRoutingDialog()
        : this.resetAddRoutingDialog()
    }
  },
  async mounted() {
    this.fnSearchGroupList()
    if (this.$store.state?.app.route?.params?.id) {
      this.groupId = this.$store.state?.app.route?.params?.id
      await this.fnGetTransGeneralInfo()
    }
    this.getRoomLevelOptions()
    this.getRoomOptions()
    this.fnGetNationalOptions()
    this.fnGetMarketSegmentOptions()
    this.fnGetAgentList()
    this.getAllTranPage()
    this.getTransactions()
    await this.fnGetTranpageOptions()
    this.transferTransactionSubmitForm.trans_page = this.tranpageOptions[0]?.id
  },
  methods: {
    async onRoutingSubmit() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        console.debug('onRoutingSubmit')
        return
      }
      // this.routingDialog = false
      this.createRoutingForm.booking_group_id = this.groupId
      await postRouting(this.createRoutingForm)
        .then(async res => {
          const message = res.message
          this.fnSearchGroupList()
          this.transferRoutingDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async getTransactions() {
      const data = await getTransactionListApi()
      this.transactionList = []
      data?.data.map(item => {
        if (!item.transaction_group_name) {
          this.transactionList.push(item)
        }
      })
    },
    async getAllTranPage() {
      const data = await getCodeBase({
        p_code: 'TRANPAGE'
      }).then(res => res.data)
      this.tabList = data ?? []
      this.createRoutingForm.trans_page_org = this.tabList[0]?.id
      this.createRoutingForm.trans_page_des = this.tabList[0]?.id
    },
    async getTranPageById(id, resetTab = false) {
      const params = {
        id: id
      }
      const data = await getTranPageById(params)
      this.tabList = data.data.page.map(item => {
        return {
          label: item.code,
          value: item.id,
          desc: item.desc
        }
      })
      console.debug(this.tabList)
    },
    async fnSearchGroupList() {
      await getBookingGroupListApi({
        isRoomBooking: true,
        isRoomCo: false,
        isCancel: false,
        isRoomCi: true
      })
        .then(res => {
          this.groupList = res.data
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {})
    },

    async fnGetTransGeneralInfo() {
      // console.log(value);
      // this.groupId = await value?.id
      this.tabIndex = 1
      // const agGrid = this.$refs.customerGrid.gridApi
      // const row = agGrid.getSelectedRows()[0]
      // if (!row.id) return
      this.customerInfo = Object.assign({}, this.customerInfoDefault)
      this.transactionRows = []
      this.selectedRows = []
      const params = {
        id: this.groupId
      }
      const data = await getTransGeneralInfo(params)
      if (data?.data !== null && data?.data !== undefined) {
        this.customerInfo = data.data
        if (this.customerInfo.transaction_page?.length !== 0) {
          this.customerInfo.transaction_page =
            this.customerInfo.transaction_page.map(item => {
              return {
                label: item.code,
                value: item.id
              }
            })
          await this.fnGetTransactionByPage(
            this.customerInfo.transaction_page[0]?.value
          )
        }
      }
      // this.tab
    },
    async changeGroupSelect(value) {
      this.groupId = await value?.id
      this.fnGetTransGeneralInfo()
    },
    async fnGetTransactionByPage(transPage) {
      // const agGrid = this.$refs.customerGrid.gridApi
      // const row = agGrid.getSelectedRows()[0]
      const params = {
        id: this.groupId,
        pageId: transPage
      }
      if (!transPage) {
        this.transactionRows = []
        return
      }
      const data = await getTransactionByPage(params)
      this.transactionRows = data.data
    },
    async onTabChange(idx) {
      const id = this.customerInfo.transaction_page[idx - 1].value

      this.selectedRows = []
      await this.fnGetTransactionByPage(id)
    },
    onSelectTransaction(select) {
      this.selectedRows = select
    },
    searchRoomOnTransferTransactionDialog(type) {
      this.searchFolioType = type
      this.searchFolioDialog = true
    },
    async onTransferTransaction() {
      if (
        (await this.$vxForm.isValid(
          this.$refs.tranferTransactionsFormValidator
        )) === false
      ) {
        return
      }
      const ids = {
        list_ids: this.selectedRows.map(item => item.id)
      }
      const data = { ...this.transferTransactionSubmitForm, ...ids }
      await transferTransactionApi(data)
        .then(async res => {
          const message = res.message
          this.transferTransactionDialog = false
          this.transactionProcessDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {
          this.transferTransactionDialog = false
          this.transferTransactionSubmitForm = Object.assign(
            {},
            this.transferTransactionSubmitFormDefault
          )
          this.transferTransactionSubmitForm.trans_page =
            this.tranpageOptions[0]?.id

          this.fnGetTransGeneralInfo()
        })
    },
    async getRoomLevelOptions() {
      const data = await getListRoomLevelApi()
      this.roomLevelOptions = data?.data || []
      // await getRoom()
    },
    async getRoomOptions() {
      const data = await getRoom()
      this.roomOptions = data?.data || []
    },
    async fnGetNationalOptions() {
      const data = await codeBaseApi({ pCode: 'NATION' })
      this.nationOptions = data.data ?? []
    },
    async fnGetTranpageOptions() {
      const data = await codeBaseApi({ pCode: 'TRANPAGE' })
      this.tranpageOptions = data.data ?? []
    },
    async fnGetMarketSegmentOptions() {
      const data = await getMarketSegmentApi({ isActive: 1 })
      this.marketSegmentList = data.data ?? []
    },
    async fnGetAgentList() {
      await getAgent()
        .then(res => {
          this.agentList = res.data
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {})
    },
    onSelectNation(data) {
      this.searchParamsFolioAdvance.nation_id = data?.id || null
    },

    async onReset() {
      this.searchParamsFolio = Object.assign({}, this.searchParamsFolioDefaut)
      this.searchParamsFolioAdvance = Object.assign(
        {},
        this.searchParamsFolioAdvanceDefault
      )
    },

    async searchFolio() {
      if (
        (await this.$vxForm.isValid(this.$refs.validateSearchForm)) === false
      ) {
        return
      }
      const data = await searchFolioApi(this.searchParamsFolio)
      this.folioListRows = data?.data || []
      if (this.folioListRows.length === 0) {
        this.$message({
          type: 'warning',
          message: 'Không có dữ liệu'
        })
        return
      }
      this.folioListDialog = true
    },
    async searchFolioAdvance() {
      if (
        (await this.$vxForm.isValid(this.$refs.validateAdvanceSearchForm)) ===
        false
      ) {
        return
      }
      const data = await searchFolioAdvanceApi(this.searchParamsFolioAdvance)
      this.folioListRows = data?.data || []
      if (this.folioListRows.length === 0) {
        this.$message({
          type: 'warning',
          message: 'Không có dữ liệu'
        })
        return
      }
      this.folioListDialog = true
    },
    onSelectFolioRows(select) {
      this.selectedFolio = select[0]
    },
    onFolioSelect() {
      // this.searchFolioType = type
      // const agGrid = this.$refs.folioListGrid.gridApi
      // const row = agGrid.getSelectedRows()[0]
      const row = this.selectedFolio
      if (row === null) {
        this.$message({ type: 'error', message: 'Vui lòng chọn Folio' })
        return
      }
      // if (this.searchFolioType === 1) {
      //   this.createRoutingForm.sub_booking_group_id_des = row.id
      //   this.createRoutingForm.sub_booking_group_name_des = row.full_name
      // } else {
      this.transferTransactionSubmitForm.sub_booking_group_id = row.id
      this.transferTransactionSubmitForm.room_code = row.room_code
      this.transferTransactionSubmitForm.customer_name = row.full_name
      this.transferTransactionSubmitForm.room_num = row.room_num
      // }

      this.folioListDialog = false
      this.searchFolioDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.mb-2 {
  margin-bottom: 8px;
}
.pt-2 {
  padding-top: 8px;
}
.w-20 {
  width: 20%;
}
.remaining-money {
  font-weight: 700;
  color: #357456;
}
.block {
  display: block !important;
}
</style>
